import React from "react";
import { Link } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import CallIcon from "@material-ui/icons/Call";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#0f172a",
        color: "#94a3b8",
        borderTop: "1px solid #1e293b",
        paddingTop: "60px",
        paddingBottom: "32px",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5} justify="space-between">
          {/* Brand Col */}
          <Grid item xs={12} md={4}>
            <Link
              to="/"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                marginBottom: "16px",
              }}
            >
              <img
                src="https://ik.imagekit.io/urhub/assets/misc/logo-white-only.png"
                alt="UR Logo"
                style={{ height: "32px", width: "auto" }}
              />
              {/* <span
                style={{
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "18px",
                  letterSpacing: "-0.02em",
                }}
              >
                UR
              </span> */}
            </Link>

            <p
              style={{
                color: "#94a3b8",
                fontSize: "14px",
                lineHeight: 1.7,
                marginBottom: "20px",
                maxWidth: "320px",
              }}
            >
              Platform POS &amp; Self Order untuk efisiensi operasional
              restoran, cafe, dan bisnis kuliner di Indonesia.
            </p>

            {/* <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 12px",
                borderRadius: "6px",
                backgroundColor: "rgba(34, 197, 94, 0.08)",
                border: "1px solid rgba(34, 197, 94, 0.2)",
                fontSize: "12px",
                color: "#4ade80",
                fontWeight: 500,
              }}
            >
              <span
                style={{
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  backgroundColor: "#22c55e",
                }}
              />
              Sistem Beroperasi Normal
            </div> */}
          </Grid>

          {/* Nav Col 1: Produk */}
          <Grid item xs={6} sm={4} md={2}>
            <div
              style={{
                color: "#f8fafc",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "16px",
              }}
            >
              Produk
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <Link
                to="/"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                POS Kasir
              </Link>
              <Link
                to="/"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Self Order QR
              </Link>
              <Link
                to="/partner"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                UR Partner
              </Link>
              <Link
                to="/pricing"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Paket &amp; Harga
              </Link>
              <Link
                to="/blog"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Blog
              </Link>
            </div>
          </Grid>

          {/* Nav Col 2: Bantuan & Legal */}
          <Grid item xs={6} sm={4} md={3}>
            <div
              style={{
                color: "#f8fafc",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "16px",
              }}
            >
              Bantuan &amp; Legal
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <Link
                to="/pusat-bantuan/user"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Bantuan Pengguna
              </Link>
              <Link
                to="/pusat-bantuan/partner"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Bantuan Partner
              </Link>
              <Link
                to="/faqs"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                FAQs
              </Link>
              <Link
                to="/syarat-dan-ketentuan"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Syarat &amp; Ketentuan
              </Link>
              <Link
                to="/kebijakan-privasi"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Kebijakan Privasi
              </Link>
              <Link
                to="/karir"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                Karir
              </Link>
            </div>
          </Grid>

          {/* Contact & Download */}
          <Grid item xs={12} sm={4} md={3}>
            <div
              style={{
                color: "#f8fafc",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "16px",
              }}
            >
              Hubungi Kami
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "18px",
              }}
            >
              <a
                href="https://wa.me/6287777077771"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <CallIcon fontSize="small" style={{ fontSize: "16px" }} />
                087-7770-7777-1
              </a>
              <a
                href="mailto:support@ur-hub.com"
                style={{
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <EmailIcon fontSize="small" style={{ fontSize: "16px" }} />
                support@ur-hub.com
              </a>
            </div>

            {/* App Store Badges */}
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                marginBottom: "18px",
              }}
            >
              <a
                href="https://apps.apple.com/id/app/ur-partner-pos-system/id1572223994"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://ik.imagekit.io/urhub/assets/misc/app-store-icon.png"
                  alt="App Store"
                  style={{ height: "34px", borderRadius: "5px" }}
                />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.urpartner"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://ik.imagekit.io/urhub/assets/misc/google-play-icon.png"
                  alt="Google Play"
                  style={{ height: "34px", borderRadius: "5px" }}
                />
              </a>
            </div>

            {/* Social Icons */}
            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
              <a
                href="https://www.facebook.com/UR-Self-Order-App-101245531496672/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#64748B" }}
              >
                <FacebookIcon fontSize="small" />
              </a>
              <a
                href="https://www.instagram.com/ur.hub/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#64748B" }}
              >
                <InstagramIcon fontSize="small" />
              </a>
              <a
                href="https://www.linkedin.com/company/ur-hub/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#64748B" }}
              >
                <LinkedInIcon fontSize="small" />
              </a>
            </div>
          </Grid>
        </Grid>

        {/* Divider */}
        <div
          style={{
            borderTop: "1px solid #1e293b",
            marginTop: "40px",
            paddingTop: "20px",
          }}
        >
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
            Copyright © 2026 PT. Rahmat Tuhan Lestari. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
